import React from 'react';
import { StyledCRSTaxDisclosureText } from './StyledComponents';
import { getContent } from '@/lib';

export const CRSTaxDisclosure = (): JSX.Element => {
  return (
    <StyledCRSTaxDisclosureText>
      {getContent('crs.declaration')}
    </StyledCRSTaxDisclosureText>
  );
};
